'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('egAngularUtils', ['ng']);
/* @ngInject */
function DateCompareDirective() {
    return {
        link: link,
        restrict: 'A',
        require: 'ngModel'
    };

    function link($scope, element, attributes, ngModel) {
        var statesToWatch = [attributes.ngModel, attributes.egDateCompare];

        $scope.$watchGroup(statesToWatch, function (newValues) {
            var thisDate = newValues[0];
            var otherDate = newValues[1];

            if (!thisDate || !otherDate) {
                ngModel.$setValidity('egDateCompare', true);
                return;
            }

            var thisTime = thisDate.getTime();
            var otherTime = otherDate.getTime();
            var validity;

            switch (attributes.egDateCompareMode) {
                case 'lt':
                    validity = thisTime < otherTime;
                    break;
                case 'lte':
                    validity = thisTime <= otherTime;
                    break;
                case 'gt':
                    validity = thisTime > otherTime;
                    break;
                case 'gte':
                    validity = thisTime >= otherTime;
                    break;
                default:
                    throw new Error('Unsupported date compare mode: ' + attributes.egDateCompareMode);
            }

            ngModel.$setValidity('egDateCompare', validity);
        });
    }
}

angular.module('egAngularUtils').directive('egDateCompare', DateCompareDirective);
(function () {
    var iso8601 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;

    function isIso8601(value) {
        return angular.isString(value) && iso8601.test(value);
    }

    function convertToDate(input) {
        if (!angular.isObject(input)) {
            return input;
        }

        angular.forEach(input, function (value, key) {
            if (isIso8601(value)) {
                input[key] = new Date(value);
            } else if (angular.isObject(value)) {
                convertToDate(value);
            }
        });
    }

    /* @ngInject */
    function DateInterceptor() {
        return {
            'response': function response(_response) {
                convertToDate(_response.data);
                return _response;
            }
        };
    }

    /* @ngInject */
    function DateInterceptorConfig($httpProvider) {
        $httpProvider.interceptors.push(DateInterceptor);
    }

    angular.module('egAngularUtils').config(DateInterceptorConfig);
})();
/* @ngInject */
function FormGroupStateDirective() {
    return {
        link: link,
        restrict: 'A'
    };

    function link(scope, element, attrs) {
        var states = [attrs.egFormGroupState + '.$dirty', attrs.egFormGroupState + '.$touched', attrs.egFormGroupState + '.$invalid'];

        scope.$watchGroup(states, function (newValues) {
            var dirty = newValues[0];
            var touched = newValues[1];
            var invalid = newValues[2];
            if (dirty && touched && invalid) {
                element.addClass('has-error');
                element.removeClass('has-success');
            } else if (dirty && touched) {
                element.addClass('has-success');
                element.removeClass('has-error');
            } else {
                element.removeClass('has-success');
                element.removeClass('has-error');
            }
        });
    }
}

angular.module('egAngularUtils').directive('egFormGroupState', FormGroupStateDirective);
function IframeResizerDirective() {
    return {
        restrict: 'A',
        scope: {
            'egIframeResizer': '='
        },
        link: link
    };

    function link(scope, element) {
        iFrameResize(scope.egIframeResizer, element[0]);
    }
}

angular.module('egAngularUtils').directive('egIframeResizer', IframeResizerDirective);
function ShowDeletedFilter() {
    return function (entityArray, showDeleted) {
        return entityArray.filter(function (entity) {
            return showDeleted || !entity.deleted;
        });
    };
}

angular.module('egAngularUtils').filter('egShowDeleted', ShowDeletedFilter);
/* @ngInject */
function SrcDirective(CONTEXT_PATH, $log) {
    return {
        link: link,
        restrict: 'A',
        scope: {
            egSrc: '@'
        }
    };

    function link(scope, element) {
        $log.warn('The egSrc directive is deprecated. Please use the egUrl filter instead');
        element.attr('src', CONTEXT_PATH + scope.egSrc);
    }
}

angular.module('egAngularUtils').directive('egSrc', SrcDirective);
/* @ngInject */
function UrlFilter(CONTEXT_PATH) {
    return function (url) {
        if (url.charAt(0) !== '/') {
            throw new Error('Url \'' + url + '\' must be absolute');
        }

        return CONTEXT_PATH + url;
    };
}

angular.module('egAngularUtils').filter('egUrl', UrlFilter);

var UrlService = function () {
    /* @ngInject */
    function UrlService(CONTEXT_PATH, $log) {
        _classCallCheck(this, UrlService);

        this.$log = $log;
        this.contextPath = CONTEXT_PATH;
    }

    _createClass(UrlService, [{
        key: 'url',
        value: function url(path, parameters) {
            var returnUrl = this.contextPath + path;

            if (parameters) {
                for (var key in parameters) {
                    if (!parameters.hasOwnProperty(key)) {
                        continue;
                    }

                    var value = encodeURIComponent(parameters[key]);
                    returnUrl = returnUrl.replace('{{' + key + '}}', value);
                }
            }

            return returnUrl;
        }
    }]);

    return UrlService;
}();

angular.module('egAngularUtils').service('egUrlService', UrlService);